import React from 'react';

const LoadingSkeleton = ({ count = 1, className = '' }) => {
  return (
    <div className={className}>
      {[...Array(count)].map((_, i) => (
        <div key={i} className="animate-pulse mb-4">
          <div className="h-4 bg-dark-500 rounded mb-2" style={{ width: i % 2 === 0 ? '80%' : '60%' }}></div>
          <div className="h-3 bg-dark-500 rounded" style={{ width: '100%' }}></div>
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;